import { render, staticRenderFns } from "./file-upload-and-save-to-config.vue?vue&type=template&id=b8d15c50"
import script from "./file-upload-and-save-to-config.vue?vue&type=script&lang=js"
export * from "./file-upload-and-save-to-config.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports